import { render } from "./logo.vue?vue&type=template&id=4320c951&ts=true"
import script from "./logo.vue?vue&type=script&lang=ts"
export * from "./logo.vue?vue&type=script&lang=ts"

import "./logo.vue?vue&type=style&index=0&id=4320c951&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__